module.exports = __webpack_public_path__ + "static/media/logintitle.660db2ea.svg";